import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initializeSentry } from './services/errorReporting';
import App from './App';
import LocalizationProvider from './components/lang/LocalizationProvider';
import ErrorBoundary from './components/error/ErrorBoundary';
import { preventTranslationCrash } from './utils/preventTranslationCrash';
import './index.static.scss';

initializeSentry();

preventTranslationCrash();

createRoot(document.querySelector('#root') as HTMLElement).render(
  <ErrorBoundary>
    <BrowserRouter>
      <LocalizationProvider>
        <App />
      </LocalizationProvider>
    </BrowserRouter>
  </ErrorBoundary>,
);
